import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { positions, Provider, transitions } from "react-alert";
import { KAlertTemplate } from "./KAlertTemplate";
import KAlertContainer from "./KAlertContainer";
export const KAlertProvider = ({ children, timeout = 10000 }) => {
    return (_jsxs(Provider, { template: KAlertTemplate, position: positions.BOTTOM_CENTER, timeout: timeout, offset: "10px", transition: transitions.FADE, containerStyle: { zIndex: 990000 }, children: [children, _jsx(KAlertContainer, {})] }));
};
